import React from 'react';
import {View, ViewStyle} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {stylePatterns} from '../../../../../shared/theme/patterns';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';
import {ProfileApplicationsStatus} from '../../../../../shared/models/profile/applications';
import {useTheme} from '../../../../../shared/theme';
import {Text} from '../../../../../shared/components/text';
import {DeviceSize} from '../../../../../shared/theme/helpers';

export const ApplicationsItemStatus: React.FC<{statusId?: ProfileApplicationsStatus; statusName?: string}> = ({
  statusId,
  statusName,
}) => {
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    wrap: {
      ...stylePatterns.flexCenterVertical,
      justifyContent: 'flex-end',
    },
    text: {
      paddingLeft: isDesktop ? 14 : 10,
    },
    statusText: mediaOnly(DeviceSize.desktop, theme.fonts.h5, theme.fonts.action),
  }));

  const color = theme.applications.statusColors[statusId || ProfileApplicationsStatus.accepted];

  return (
    <View style={[styles.wrap, {color} as ViewStyle]}>
      <Text style={[styles.text, styles.statusText, {color}]} testID='application-status-name'>
        {statusName}
      </Text>
    </View>
  );
};
